import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useSocket } from '../context/socket'
import Badge from './Badge'
import { useTranslation } from 'react-i18next'
import { ReactComponent as FeedTaskIcon } from '../svg/normalSvgs/FeedTaskIcon.svg'
import { ReactComponent as UpstriveLogo } from '../svg/normalSvgs/UpstriveLogo.svg'
import { ReactComponent as SolutionIcon } from '../svg/normalSvgs/SolutionIcon.svg'
import { ReactComponent as ChatNavIcon } from '../svg/normalSvgs/ChatNavIcon.svg'
import { ReactComponent as ProfileNavIcon } from '../svg/normalSvgs/ProfileNavIcon.svg'
import { ReactComponent as AlkalmaLogo } from '../AlkalmaLogoWhiteOnBlue.svg'
import { useLocation } from 'react-router-dom'

const activeColor = '#4eacaa' //mint lagoon
const inactiveColor = '#FFFFFF'

export default function Menu({ toggleInstructionVideo, setActiveSection, activeSection }) {
    const { socketStates } = useSocket()
    const numberOfUnseenConversations = socketStates?.unseenConversations?.length || 0
    const numberOfTasks = socketStates?.tasks?.length || 0
    const { t } = useTranslation()
    const location = useLocation()

    useEffect(() => {
        switch (location.pathname) {
            case '/home':
                setActiveSection('home')
                break
            case '/solutions':
                setActiveSection('solutions')
                break
            case '/chat':
                setActiveSection('chat')
                break
            case '/profile':
                setActiveSection('profile')
                break
            default:
                setActiveSection('home')
        }
    }, [location.pathname, setActiveSection])
    return (
        <div className="header" id="my-header">
            <div className="menu">
                <div className="menu-link-logo">
                    <Link onClick={() => setActiveSection('home')} to="/home" className={`router-link  ${activeSection === 'home' ? 'active-link' : ''} `}>
                        <AlkalmaLogo height={60} width={150} />
                    </Link>
                </div>
                <div style={{ flex: 1 }}></div>
                <div className="menu-link">
                    <Link onClick={() => setActiveSection('home')} to="/home" className={`router-link  ${activeSection === 'home' ? 'active-link' : ''} menu-link`}>
                        <div className="menu-icon">
                            {!!numberOfTasks && <Badge number={''} style={{ height: 10, width: 10, padding: 0, minWidth: 0, minHeight: 0 }} />}
                            <FeedTaskIcon style={{ color: activeSection === 'home' ? activeColor : inactiveColor }} />
                        </div>
                        <div className="menu-nav-text" style={{ color: activeSection === 'home' ? activeColor : inactiveColor }}>
                            {t('home')}
                        </div>
                    </Link>
                </div>
                <div className="menu-link">
                    <Link onClick={() => setActiveSection('solutions')} to="/solutions" className={`router-link  ${activeSection === 'solutions' ? 'active-link' : ''} menu-link`}>
                        <div className="menu-icon">
                            <SolutionIcon style={{ color: activeSection === 'solutions' ? activeColor : inactiveColor }} />
                        </div>
                        <div className="menu-nav-text" style={{ color: activeSection === 'solutions' ? activeColor : inactiveColor }}>
                            {t('solutions')}
                        </div>
                    </Link>
                </div>
                <div className="menu-link">
                    <Link onClick={() => setActiveSection('chat')} to="/chat" className={`router-link  ${activeSection === 'chat' ? 'active-link' : ''} menu-link`}>
                        <div className="menu-icon" style={{ paddingTop: 2 }}>
                            {!!numberOfUnseenConversations && <Badge number={''} style={{ height: 10, width: 10, padding: 0, minWidth: 0, minHeight: 0 }} />}
                            <ChatNavIcon style={{ color: activeSection === 'chat' ? activeColor : inactiveColor }} />
                        </div>
                        <div className="menu-nav-text" style={{ color: activeSection === 'chat' ? activeColor : inactiveColor }}>
                            {t('chat')}
                        </div>
                    </Link>
                </div>
                <div className="menu-link" onClick={() => setActiveSection('profile')}>
                    <Link to="/profile" className={`router-link menu-profile-margin ${activeSection === 'profile' ? 'active-link' : ''} `}>
                        <div className="menu-icon">
                            <ProfileNavIcon style={{ color: activeSection === 'profile' ? activeColor : inactiveColor }} />
                        </div>
                        <div className="menu-nav-text" style={{ color: activeSection === 'profile' ? activeColor : inactiveColor }}>
                            {t('profile')}
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    )
}
